/* istanbul ignore file */

import { css } from 'styled-components';
export var buttonReset = /*#__PURE__*/css(["background-color:transparent;border:none;cursor:pointer;"]);
export var baseStyles = /*#__PURE__*/css(["text-align:center;"]);
export var baseLink = /*#__PURE__*/css(["", " text-decoration:none;display:inline-block;"], baseStyles);
export var baseButton = /*#__PURE__*/css(["", " ", " &:disabled{pointer-events:none;}"], buttonReset, baseStyles);
export var buttonContentTextColor = {
  brand: css(["color:var(--brand-purple-base);"]),
  dark: css(["color:var(--neutral-black-base);"]),
  light: css(["color:var(--neutral-white-base);"])
};